import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../DialogResult";
import {
  DropDownItem,
  UdInteractFilters,
  US_SubHeader,
  US_Filter,
} from "../../api/models";
import { ShareState } from "../../elements/share-editor/share-editor.component";

export interface EditInteractiveFilterDialogData {
  userSubscriptions: US_SubHeader[];
  filter: US_Filter;
  shareState: ShareState;
  isNew: boolean;
  isOwner: boolean;
  updateData: boolean;
}

@Component({
  selector: "edit-interactive-filter-dialog",
  templateUrl: "./edit-interactive-filter-dialog.component.html",
})
export class EditInteractiveFilterDialogComponent implements OnInit {
  public Result: DialogResult;

  constructor(
    public dialogRef: MatDialogRef<EditInteractiveFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditInteractiveFilterDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = data;
  }
  ngOnInit(): void {}

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.dialogRef.close(this.Result);
  }
}
